import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { AccountancyGridItem } from '@skylab-shared/business';

import { FormsModule } from '@angular/forms';
import { AccountancyRepository, AccountancyRepositoryBase } from '@skylab-angular-shared/business';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentBase, DialogContentComponentIns, DialogContentViewModel, DialogHeaderComponentIns, DialogInsService, DialogState, FormContainerComponent, PasswordComponentIns } from '@skylab-angular-shared/ui';

interface DownloadDataExchangeDocumentDialogViewModel extends DialogContentViewModel {
    params: {
        compression: boolean;
        compressionOnly: boolean;
        password: string;
    };
}
@Component({
    selector: 'skl-accountancy-download-data-exchange-dialog',
    templateUrl: './accountancy-download-data-exchange-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, BooleanValueAccessorDirective, FormsModule, PasswordComponentIns, ButtonComponent, TranslatePipe]
})
export class AccountancyDownloadDataExchangeDialogComponent extends DialogContentComponentBase<DownloadDataExchangeDocumentDialogViewModel, AccountancyGridItem> {
    public constructor(
        @Inject(AccountancyRepository) private readonly accountancyRepository: AccountancyRepositoryBase,
        dialogService: DialogInsService
    ) {
        super(dialogService);
    }

    protected override getInitialState(): DownloadDataExchangeDocumentDialogViewModel {
        return {
            params: {
                compressionOnly: this.data.attachments.length > 1,
                compression: this.data.attachments.length > 1,
                password: ''
            }
        };
    }

    public isDownloading!: boolean;
    public async downloadDocumentAsync(): Promise<void> {
        try {
            this.isDownloading = true;
            await this.accountancyRepository.downloadDocumentAsync(
                this.data.id,
                {
                    compress: this.viewModel.params.compression,
                    password: this.viewModel.params.password
                }
            );
            this.dialogService.close({ state: DialogState.Confirm });
        } catch (err) {
            this.logger.error(err);
        } finally {
            this.isDownloading = false;
        }
    }
}
